module.exports = __webpack_public_path__ + "img/alevel.1326a24c.png";